// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__34FEZ","productName":"Table_productName__ZQKC9"};